import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
/**
 * Manages application events
 */
export class EventsService {

    languageSelectedEvent = new EventEmitter()
    constructor() {
    }
}
